import qs from "query-string";

export default function buildLink(context, href, params = {}) {
    const newParams = Object.assign({}, context.queryString, params);
    const queryString = qs.stringify(newParams);
    return `${href}?${queryString}`;
}
